import React, { useState, useEffect } from 'react'
import { Formik, Form, useFormikContext, useField } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import axios from 'axios'
import { APIURL } from '../../../hoc/AxiosSetting/axios'

const MyField = props => {
    const {
        values: { generalPermanent, generalContractual, generalPartTime, genralSesonal },
        // touched,
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
        // if (touched.generalPermanent && touched.generalContractual && touched.generalPartTime && touched.genralSesonal) {
            var total = parseInt(generalPermanent) + parseInt(generalContractual) + parseInt(generalPartTime) + parseInt(genralSesonal)
            setFieldValue(props.name, `${total}`);
        // }
    }, [generalPermanent, generalContractual, generalPartTime, genralSesonal,
        // touched.generalPermanent, touched.generalContractual, touched.generalPartTime, touched.genralSesonal,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const FirstShiftTotal = props => {
    const {
        values: { firstShiftPermanent, firstShiftContractual, firstShiftPartTime, firstShiftSesonal },
     
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
        
            var total1 = parseInt(firstShiftPermanent) + parseInt(firstShiftContractual) + parseInt(firstShiftPartTime) + parseInt(firstShiftSesonal)
            setFieldValue(props.name, `${total1}`);
       
    }, [firstShiftPermanent, firstShiftContractual, firstShiftPartTime, firstShiftSesonal,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const SecondShiftTotal = props => {
    const {
        values: { secondShiftPermanent, secondShiftContractual, secondShiftPartTime, secondShiftSesonal },
        // touched,
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
      
            var total1 = parseInt(secondShiftPermanent) + parseInt(secondShiftContractual) + parseInt(secondShiftPartTime) + parseInt(secondShiftSesonal)
            setFieldValue(props.name, `${total1}`);
       
    }, [secondShiftPermanent, secondShiftContractual, secondShiftPartTime, secondShiftSesonal,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const ThirdShiftTotal = props => {

    const {
        values: { thirdShiftPermanent, thirdShiftContractual, thirdShiftPartTime, thirdShiftSesonal },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(thirdShiftPermanent) + parseInt(thirdShiftContractual) + parseInt(thirdShiftPartTime) + parseInt(thirdShiftSesonal)
            setFieldValue(props.name, `${total1}`);
    }, [thirdShiftPermanent, thirdShiftContractual, thirdShiftPartTime, thirdShiftSesonal,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const PermenentShiftTotal = props => {

    const {
        values: { firstShiftPermanent, secondShiftPermanent, thirdShiftPermanent, generalPermanent },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(firstShiftPermanent) + parseInt(secondShiftPermanent) + parseInt(thirdShiftPermanent) + parseInt(generalPermanent)
            setFieldValue(props.name, `${total1}`);
            }, [firstShiftPermanent, secondShiftPermanent, thirdShiftPermanent, generalPermanent,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const ContractiulShiftTotal = props => {

    const {
        values: { generalContractual, firstShiftContractual, secondShiftContractual, thirdShiftContractual },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(generalContractual) + parseInt(firstShiftContractual) + parseInt(secondShiftContractual) + parseInt(thirdShiftContractual)
            setFieldValue(props.name, `${total1}`);
    }, [generalContractual, firstShiftContractual, secondShiftContractual, thirdShiftContractual,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const PartShiftTotal = props => {

    const {
        values: { generalPartTime, firstShiftPartTime, secondShiftPartTime, thirdShiftPartTime },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(generalPartTime) + parseInt(firstShiftPartTime) + parseInt(secondShiftPartTime) + parseInt(thirdShiftPartTime)
            setFieldValue(props.name, `${total1}`);
    }, [generalPartTime, firstShiftPartTime, secondShiftPartTime, thirdShiftPartTime,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const SeasonalTotal = props => {

    const {
        values: { genralSesonal, firstShiftSesonal, secondShiftSesonal, thirdShiftSesonal },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(genralSesonal) + parseInt(firstShiftSesonal) + parseInt(secondShiftSesonal) + parseInt(thirdShiftSesonal)
            setFieldValue(props.name, `${total1}`);
    }, [genralSesonal, firstShiftSesonal, secondShiftSesonal, thirdShiftSesonal,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const Total = props => {
    const {
        values: { permanentTotal, contractualTotal, partTimeTotal, SeasonalTotal },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(permanentTotal) + parseInt(contractualTotal) + parseInt(partTimeTotal) + parseInt(SeasonalTotal)
            setFieldValue(props.name, `${total1}`);
    }, [permanentTotal, contractualTotal, partTimeTotal, SeasonalTotal,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
const EffectiveNumber = props => {
    const {
        values: { total, repatativeprocessbyemp },
        setFieldValue
    } = useFormikContext();
    const [field, meta] = useField(props);

    React.useEffect(() => {
            var total1 = parseInt(total) - parseInt(repatativeprocessbyemp)
            setFieldValue(props.name, `${total1}`);
    }, [total, repatativeprocessbyemp,
        setFieldValue, props.name]);


    return (
        <>
            <input {...props} {...field} />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
    );
};
function Rfq() {
    const history = useHistory();
    const { orgcode } = useParams()

    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        orgName: "",
        orgType: "",
        address: "",
        pinCode: "",
        contactPersonName: "",
        position: "",
        mobile: "",
        telephone: "",
        email: "",
        scope: "",
        typeOfCertification: "",

        noOfFixedLoc: "",
        noOfTempLoc: 0,
        prevOrgDetails: "",

        generalPermanent: 0,
        generalContractual: 0,
        generalPartTime: 0,
        genralSesonal: 0,
        genralTotal: 0,

        firstShiftPermanent: 0,
        firstShiftContractual: 0,
        firstShiftPartTime: 0,
        firstShiftSesonal: 0,
        firstShiftTotal: 0,

        secondShiftPermanent: 0,
        secondShiftContractual: 0,
        secondShiftPartTime: 0,
        secondShiftSesonal: 0,
        secondShiftTotal: 0,

        thirdShiftPermanent: 0,
        thirdShiftContractual: 0,
        thirdShiftPartTime: 0,
        thirdShiftSesonal: 0,
        thirdShiftTotal: 0,

        permanentTotal: 0,
        contractualTotal: 0,
        partTimeTotal: 0,
        SeasonalTotal: 0,
        total: 0,

        permanentEmp: 0,
        partTimeEmp: 0,
        temporaryEmp: 0,
        totalEmp: 0,
        effectiveNoEmpToBeAudited: 0,
        repatativeprocessbyemp: 0,
        justificationEffNoEmpConsideration: "",

        prodProDesc: "",
        lineOfProcessesForProducts: "",
        outsourcedProcessList: "",

        requirements: "",
        logistics: "",
        languageUsedInOrg: "",
        areaOfLocations: "",
        qmsImplementationTime: "",
        noOfEmpDoingSameTask: "",
        sameActivitiesbyShifts: "",
        qmsImplementationConsultancy: "",

        noofsites:"",
        noofserver:"",
        noofwspclp:"",
        datacenterdetails:"",
        noofappluser :"",
        noofinfrauser :"",
        noofappdev :"",

        haveconductedoneinternal:"Yes",
        haveyoureview:"Yes",
        policy:"Yes",
        desofitinfra:"Yes",
        assetinventory:"Yes",
        idenandmethodology:"Yes",
        riskassceementreport:"Yes",
        risktreatmentplan:"Yes",
        stateappwrtiso:"Yes",
        procedureandcontrol:"Yes",
        recordsreqbystandard:"Yes",
        itsecurityman:"Yes",
        internalitsecauudit:"Yes",
        detailsofservice:"Yes",
        
        noofcustomer:"",

        compImpSingularMgmt: "Yes",
        additionalFacilitiesCovUnderOneCert: "Yes",
        additionalFacilitiesCovUnderSeprateCert: "Yes",

        nameCurCertBody: "",
        currentSurvAuditBeingDone: "",
        reasonsForChange: "",
        compCurrOnSuspension: "No",
        compCurrOnSuspensionDes: "",

        nameOfPersonProvidingInfo: "",
        positionOfPersonProvidingInfo: "",
        ageOfPersonProvidingInfo: new Date(),
        mgmtStdExclusion: "",

        gstNo: "",
        panNo: "",
        expirydateOfCertification: new Date(),
        createdBy:localStorage.getItem("userCode"),
        createdByRole : localStorage.getItem("userRole")

    })
    const [datashow, setdatashow] = useState(false);
    const validationSchema = Yup.object({
        orgName: Yup.string().required('Required!!'),
        orgType: Yup.string().required('Required!!'),
        address: Yup.string().required('Required!!'),
        contactPersonName: Yup.string().required('Required!!'),
        position: Yup.string().required('Required!!'),
        gstNo: Yup.string().length(15,"Exactly 15 characters allowed!!").matches(/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/, "Invalid GST Number!!"),
        panNo: Yup.string().length(10,"Exactly 10 characters allowed!!").matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number!!!"),
        mobile: Yup.string().trim().required('Required!!').matches(/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/, "Phone Number is Invalid!!!"),
        email: Yup.string().email('Invalid Email Format').required('Required!!'),
        scope: Yup.string().required('Required!!'),
        typeOfCertification: Yup.string().required('Required!!'),
        noOfFixedLoc: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        generalPermanent: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        generalContractual: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        generalPartTime: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        genralSesonal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        genralTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        firstShiftPermanent: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        firstShiftContractual: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        firstShiftPartTime: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        firstShiftSesonal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        firstShiftTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),

        secondShiftPermanent: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        secondShiftContractual: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        secondShiftPartTime: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        secondShiftSesonal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        secondShiftTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),

        thirdShiftPermanent: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        thirdShiftContractual: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        thirdShiftPartTime: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        thirdShiftSesonal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        thirdShiftTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),

        permanentTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        contractualTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        partTimeTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        SeasonalTotal: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        total: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),

        permanentEmp: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        partTimeEmp: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        temporaryEmp: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        totalEmp: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        effectiveNoEmpToBeAudited: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        justificationEffNoEmpConsideration: Yup.string().required('Required!!'),

        prodProDesc: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        lineOfProcessesForProducts: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        outsourcedProcessList: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),

        requirements: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        logistics: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        languageUsedInOrg: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        areaOfLocations: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        qmsImplementationTime: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        noOfEmpDoingSameTask: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        sameActivitiesbyShifts: Yup.string().required('Required!!').max(250, 'Maximum 250 Characters are allowed!!'),
        compImpSingularMgmt: Yup.string().required('Required!!'),
        additionalFacilitiesCovUnderOneCert: Yup.string().required('Required!!'),
        additionalFacilitiesCovUnderSeprateCert: Yup.string().required('Required!!'),
        nameOfPersonProvidingInfo: Yup.string().required('Required!!').max(50, 'Maximum 50 Characters are allowed!!'),
        positionOfPersonProvidingInfo: Yup.string().required('Required!!').max(50, 'Maximum 50 Characters are allowed!!'),
        ageOfPersonProvidingInfo: Yup.string().required('Required!!'),
    })
    const getUrl = () =>{
        const api= APIURL + '/api/rfq/get/orgdetails/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
            if (Rfqdata && initialValues.orgCode === 0) {
                var tempData = Rfqdata.data.response
                tempData.ageOfPersonProvidingInfo = Date.parse(tempData.ageOfPersonProvidingInfo);
                tempData.expirydateOfCertification = Date.parse(tempData.expirydateOfCertification);
                setInitialValues(tempData)
            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }
        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    const onSubmit = (values, { setSubmitting, resetForm }) => {
      console.log("values",values)
        if (values._id === "") {
            mutation.mutate(values)
        } else {
            mutationEdit.mutate(values)
        }
    }


    const mutation = useMutation((params) => Fetcher('post', '/api/rfq/post/data', params), {
        onSuccess(data) {
            console.log("data",data)
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'RFQ Added')
                //history.push("/"+localStorage.getItem("role")+ '/viewrfq/' + data.data.response);
                console.log("474",data)

            } else {
                var msg = 'RFQ - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.error('Got error from backend', error)
            ToastInstance('Error', 'RFQ' + error)
        }
    })

    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/rfq/patch/rfqdata', params), {
        onSuccess(data) {
            console.log("localStorage.getItem",localStorage.getItem("role"))
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'RFQ Updated')
                history.push("/"+localStorage.getItem("role")+ '/viewrfq/' + orgcode);
            } else {
                var msg = 'RFQ - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.error('Got error from backend', error)
            ToastInstance('Error', 'RFQ' + error)
        }
    })

    const { data: OrgList, isLoading: orgLoading } = useQuery(
        'listRfq',
        () => Fetcher('get', '/api/typeoforg/get/typeoforgkeyvalue', {}))

    const { data: CertList, isLoading: certLoading } = useQuery(
        'listCert',
        () => Fetcher('get', '/api/typeofcertifications/get/typeofcertkeyvalue', {}))

    const options = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]
    const options1 = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]
    const surveillanceAudits = [
        { key: 'Select', value: '-' },
        { key: 'Annual', value: 'Annual' },
        { key: 'SemiAnnual', value: 'SemiAnnual' }
    ]

    if (orgcode && initialValues.orgCode === 0){
       
    //    window.location.href = "/signin"
       return <h1>Loading Data</h1>
      
    }
    if (orgLoading || certLoading) return <h1>Loading</h1>

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {formik =>
                    <Form>
                        <div className="content-wrapper">
                           
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="formOuterDiv ">
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='input' type='text' label='Organization Name *' name='orgName' />
                                                       
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='select' label='Organization Type *' options={OrgList.data.response} name='orgType' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Address *' name='address' />
                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='GST Number' name='gstNo' />
                                                        <FormikControl control='input' type="text" label='PAN Number' name='panNo' />
                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Contact Person Name *' name='contactPersonName' />
                                                        <FormikControl control='input' type="text" label='Position *' name='position' />
                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Mobile *' name='mobile' />
                                                        <FormikControl control='input' type="text" label='Email *' name='email' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Scope *' name='scope' />
                                                    </div>

                                                    <div className="form1RowDiv">
                                                        <FormikControl control='select' label='Type of Certification *' options={CertList.data.response} name='typeOfCertification' />
                                                    </div>
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Facility Information</h5>
                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Number of fixed Location(Eg. Factory, Warehouse, office) *' name='noOfFixedLoc'   style={{ textAlign: "right" }}/>
                                                        <FormikControl control='input' type="text" label='Number of Temporary Locations(Eg. Installations, Servicing) ' name='noOfTempLoc' style={{ textAlign: "right" }}/>
                                                    </div>
                                                    <div className="form1RowDiv mt-4">
                                                        <FormikControl control='textarea' type='text' label='If you are a part of other organization, provide details' name='prevOrgDetails' />
                                                    </div>
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Number of Employees</h5>
                                                    </div>
                                                    <div className="formRowDiv mt-4">
                                                                <div className="col-lg-11 ">
                                                                    <div class="card mb-4">
                                                                <div className="card-body table-responsive">
                                                                    <table className="table float-left">
                                                                        <thead>
                                                                            <tr>
                                                                                <td className="text-center"><b>Shift</b></td>
                                                                                <td className="text-center"><b>Permanent</b></td>
                                                                                <td className="text-center"><b>Contractual</b></td>
                                                                                <td className="text-center"><b>Part Time</b></td>
                                                                                <td className="text-center"><b>Seasonal</b></td>
                                                                                <td className="text-center"><b>Total</b></td>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="col-sm-2">General</td>
                                                                                <td className="col-sm-2">
                                                                                    <FormikControl control='inputtable' type="text" name='generalPermanent' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-2">
                                                                                    <FormikControl control='inputtable' type="text" name='generalContractual' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-2">
                                                                                    <FormikControl control='inputtable' type="text" name='generalPartTime' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-2">
                                                                                    <FormikControl control='inputtable' type="text" name='genralSesonal' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-2">
                                                                                    <MyField name="genralTotal" className="form-control" disabled={true} style={{ textAlign: "right" }} />

                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="col-sm-1 ">I st </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='firstShiftPermanent' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='firstShiftContractual' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1" >
                                                                                    <FormikControl control='inputtable' type="text" name='firstShiftPartTime' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='firstShiftSesonal' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FirstShiftTotal name="firstShiftTotal" className="form-control" disabled={true} style={{ textAlign: "right" }} />
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>II nd</td>
                                                                                <td className="col-sm-1" >
                                                                                    <FormikControl control='inputtable' type="text" name='secondShiftPermanent' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='secondShiftContractual' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1" >
                                                                                    <FormikControl control='inputtable' type="text" name='secondShiftPartTime' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td >
                                                                                    <FormikControl control='inputtable' type="text" name='secondShiftSesonal' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">

                                                                                    <SecondShiftTotal name="secondShiftTotal" className="form-control" disabled={true} style={{ textAlign: "right" }} />

                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="col-sm-1">III rd</td>
                                                                                <td className="col-sm-1 mb-3">
                                                                                    <FormikControl control='inputtable' type="text" name='thirdShiftPermanent' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='thirdShiftContractual' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='thirdShiftPartTime' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <FormikControl control='inputtable' type="text" name='thirdShiftSesonal' style={{ textAlign: "right" }} />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <ThirdShiftTotal name="thirdShiftTotal" className="form-control" disabled={true} style={{ textAlign: "right" }} />
                                                                                </td>

                                                                            </tr>
                                                                            <tr>
                                                                                <td className="col-sm-1">Total</td>
                                                                                <td className="col-sm-1" >
                                                                                    <PermenentShiftTotal name="permanentTotal" className="form-control" style={{ textAlign: "right" }} disabled />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <ContractiulShiftTotal name="contractualTotal" className="form-control" style={{ textAlign: "right" }} disabled />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <PartShiftTotal name="partTimeTotal" className="form-control" style={{ textAlign: "right" }} disabled />
                                                                                </td >
                                                                                <td className="col-sm-1">
                                                                                    <SeasonalTotal name="SeasonalTotal" className="form-control" style={{ textAlign: "right" }} disabled />
                                                                                </td>
                                                                                <td className="col-sm-1">
                                                                                    <Total name="total" className="form-control" disabled={true} style={{ textAlign: "right" }} disabled />
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <div className="formSingleElement" >
                                                            <label className="formSingleElementLabel">Permanent Employees</label>
                                                            <PermenentShiftTotal name="permanentTotal" className="formSingleElementField" style={{ textAlign: "right" }} />
                                                        </div>
                                                        <div className="formSingleElement" >
                                                            <label className="formSingleElementLabel">Employees Per Shift / Part Time Employees</label>
                                                            <PartShiftTotal name="partTimeTotal"  className="formSingleElementField" style={{textAlign:"right"}}/>
                                                        </div>
                                                  </div>

                                                  <div className="form2RowDiv">
                                                        <div className="formSingleElement" >
                                                        <label className="formSingleElementLabel">Temporary Employees</label>
                                                        <ContractiulShiftTotal name="contractualTotal"  className="formSingleElementField"style={{textAlign:"right"}}/>
                                                          
                                                        </div>
                                                        <div className="formSingleElement" >
                                                        <label  className="formSingleElementLabel">Total No of Employees</label>
                                                         <Total name="total" className="formSingleElementField" style={{textAlign:"right"}}/>
                                                           
                                                        </div>
                                                  </div>
                                                  <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='No. of Application Development and Maintenance staff *' name='noofappdev'  />
                                                    </div>
                                                  <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Repatative Process done by Emp *' name='repatativeprocessbyemp' style={{textAlign:"right"}}/>
                                                    
                                                        <div className="formSingleElement" >
                                                        <label  className="formSingleElementLabel">Effective Number of Employees to be Audited</label>
                                                         <EffectiveNumber name="effectiveNoEmpToBeAudited" className="formSingleElementField" style={{textAlign:"right"}}/>
                                                           
                                                        </div>
                                                 </div>
                                                  <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Justification for Effective Number of Employees Consideration( Ex- Shift/ Repetitive Work/ unskilled Employees) *' name='justificationEffNoEmpConsideration' />
                                                    </div>
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Information related to Product, Process and Service</h5>
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Please describe the products, processes and / or services which is deliverable to the customer and intended to be included within the scope of certification *' name='prodProDesc' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <label>Line of processes for the products / services which is deliverable (e.g, Conventional M/c, CNC Machining, Zinc Phospating,Line 1, line2, Knitting) *</label>
                                                        </div>
                                                    <div className="row">
                                                        <div className="col-sm-11" style={{marginLeft:"1%"}}>
                                                        <FormikControl control='ckEditor' type='text' label='Line of processes for the products / services which is deliverable (e.g, Conventional M/c, CNC Machining, Zinc Phospating,Line 1, line2, Knitting) *'name='lineOfProcessesForProducts' data={initialValues.lineOfProcessesForProducts} />
                                                    </div>
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='List out the processes outsourced by your organization which may affect the product quality *' name='outsourcedProcessList'  />
                                                    </div>
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Management Standard & Exclusion</h5>
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Does your orgnization has any Exclusions identified, if yes please list them out and provide the reasons / justification for exclusion' name='mgmtStdExclusion'  />
                                                    </div>
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Others </h5>
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Any other Statutory/ Regulatory/ Customer / Sector / Location requirements? *' name='requirements'  />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Whether the logistics involve more than one location where the work is carried out (E.g a separate design center, two or three units conducting same activities) *' name='logistics'  />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Languages used in your organization for communication (Covering all the staff) *' name='languageUsedInOrg' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Area of locations (Covering all the individual locations) * '  name='areaOfLocations' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='How long you have been implementing QMS. Time spent after the implementation of QMS *'  name='qmsImplementationTime' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Number of employees doing the same, simple task (e.g Packing, Movement of goods etc..) * '  name='noOfEmpDoingSameTask' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Same activities performed in all the shifts *'  name='sameActivitiesbyShifts' />
                                                    </div>
                                               
                                                    {/* <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='Number of Sites*'  name='noofsites' />
                                                    </div> */}
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type="text" label='No of Server' name='noofserver' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type="text" label='Number of WS+PC+Laptop' name='noofwspclp' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type="text" label='DataCenter  Details(If Present) ' name='datacenterdetails' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type="text" label='No of Application user' name='noofappluser' />
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type="text" label='No of Infrastructure user(Pc/laptop etc)' name='noofinfrauser' />
                                                    </div>
                                                    <div className="form1RowDiv">

                                                        <FormikControl control='textarea' type='text' label='Have you received assistance (consultancy) for the implementation of QMS?  If so provide details'  name='qmsImplementationConsultancy'/>
                                                    </div>
                                                    <div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Mandatory Information</h5>
                                                        </div>
                                                        <div className="row">
                                                        <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Have you conducted minimum one internal ISMS audit covering the scope of certification                                                               
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='haveconductedoneinternal' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Have you conducted minimum one management review covering the Scope                                                               
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='haveyoureview' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Policy                                                               
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='policy' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Description of the IT-infrastructure                                                                
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='desofitinfra' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Asset Inventory Register                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='assetinventory' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">identification and methodology of  Risk                                                                       
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='idenandmethodology' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Risk Assessment Report                                                                                                                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='riskassceementreport' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Risk Treatment  Plan                                                                                                                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='risktreatmentplan' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Statement of Applicability w.r.t. ISO 27001:2013                                                                                                                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='stateappwrtiso' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Procedures and Control Point                                                                                                                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='procedureandcontrol' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Records required by the standard                                                                                                                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='recordsreqbystandard' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">IT/Security Management                                                                                                                                      
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='itsecurityman' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Internal IT/Security Audit                                                                                                                                                                                                                                   
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='internalitsecauudit' options={options1} />
                                                                    </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                    <label htmlFor="staticEmail" className="col-sm-9">Detail of the service outsourced                                                                                                                                                                                                                                    
                                                                    <span className="required-field"> * </span>
                                                                    </label>
                                                                    <div className="col-sm-2 mt-3">
                                                                        <FormikControl control='radio' name='detailsofservice' options={options1} />
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type="text" label='No. of Customer/Projects  covered under the scope ' name='noofcustomer' />
                                                    </div>
                                                    
                                                    <p className="mt-3" style={{marginLeft:"1%"}}><i><b >NOTE: </b>Access to Organizational Records:- Before the certification audit, IQCPL shall ask the client to report if any ISMS related information (such as ISMS records or information about design and effectiveness of controls) cannot be made available for review by the audit team because it contains confidential or sensitive information. IQCPL shall determine whether the ISMS can be adequately audited in the absence of such information. If IQCPL concludes that it is not possible to adequately audit the ISMS without reviewing the identified confidential or sensitive information, it shall advise the client that the certification audit cannot take place until appropriate access arrangements are granted.</i></p>
                                                    
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Multiple Facilities Inputs</h5>
                                                    </div>                            
                                                     <div className="row">
                                                       <div className="row" style={{marginLeft:"0.5%"}}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is your company implementing a singular management system for all facilities                                                               
                                                                <span className="required-field"> * </span>
                                                                  </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='compImpSingularMgmt' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Will all additional facilities be covered under one certificate:     
                                                                <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='additionalFacilitiesCovUnderOneCert' options={options} />
                                                                </div>

                                                            </div>
                                                            <div className="row" style={{marginLeft:"0.5%"}}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Will each additional facility be covered under separate certificates:  
                                                                <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='additionalFacilitiesCovUnderSeprateCert' options={options} />
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="hrstyle headingcolor">
                                                        <h5> Current Certification /Certificate Information</h5>
                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type='text' label='Name of Current Certification Body' name='nameCurCertBody' />
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Expiry Date of Certification' name='expirydateOfCertification' />
                                                    </div>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='select'  label='Currently Surveillance audits being done'  name='currentSurvAuditBeingDone' options={surveillanceAudits}  />
                                                        <FormikControl control='input' type='text' label='Reasons for Change/transfery' name='reasonsForChange' />

                                                    </div>
                                                    <div className="row" style={{marginLeft:"0.3%"}}>
                                                    <label htmlFor="staticEmail" className="col-sm-8 mt-4">Is your company currently on suspension, or of withdrawal certification </label>
                                                                <div className="col-sm-4 mt-4">
                                                                    <FormikControl control='radio' name='compCurrOnSuspension' options={options} />
                                                                </div>
                                                     </div>
                                                     <div className="form1RowDiv">
                                                        <FormikControl control='textarea' type='text' label='If yes, please describe' name='compCurrOnSuspensionDes' />
                                                    </div>
                                                  
                                                    <p className="mt-3" style={{marginLeft:"1%"}}><i><b >NOTE: </b> Once agreement is reached that IQCPL is your certifying body, then a copy of the previous certifying body’s audit/surveillance reports and recent correspondence will be required.</i></p>
                                                   
                                                    <div className="hrstyle headingcolor">
                                                        <h5> General </h5>
                                                    </div>
                                                    <h6 className="mt-3 mb-3" style={{marginLeft:"1%"}}>Name of Person providing information for completing this Request for Quotation</h6>
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='input' type='text' label='Name *' name='nameOfPersonProvidingInfo' />
                                                        <FormikControl control='input' type='text' label='Position *' name='positionOfPersonProvidingInfo' />
                                                    </div>
                                                  
                                                   
                                                     <div className="form2RowDiv">
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date *' name='ageOfPersonProvidingInfo' />
                                                    </div>



                                                    



                                                </div>
                                                
                                              

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <div className="card-footer">
                            <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid} >Submit</button>
                                </div>

                            </div>
                        </div>
                      
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default Rfq